// The account's own lines, read once and kept in the store.
//
// Two pages want them and they must not disagree: /lines lists them and the study's picker offers
// them as one of the ways to choose what to practise. The legacy form that creates one calls
// `refresh()` when it has, so whatever is on screen follows without either side knowing about the
// other.

import { store } from "../state/index.ts";
import { K } from "../state/keys.ts";
import * as api from "./api.ts";
import type { OwnLine } from "../domain/myLines.ts";

/** Reads them from the server and publishes them. A visitor has none, and asking would be a 401. */
export async function refresh(): Promise<OwnLine[]> {
    const lines = await api.fetchLines() as OwnLine[];
    store.set(K.lines.own, lines);
    return lines;
}

/** What the store holds right now, which is nothing until somebody has asked for them. */
export function current(): OwnLine[] | null {
    return store.get(K.lines.own);
}

export function forget(): void {
    store.set(K.lines.own, null);
}

/** Takes one out, both on the server and on every screen showing it. */
export async function remove(id: number): Promise<void> {
    await api.deleteLine(id);
    store.set(K.lines.own, (current() || []).filter((line) => line.id !== id));
}

/** Turns one on or off: an inactive line is kept but not offered. */
export async function toggle(id: number): Promise<void> {
    const updated = await api.toggleLine(id) as OwnLine;
    store.set(K.lines.own, (current() || []).map((line) => (line.id === id ? updated : line)));
}
